export {
  buildAbsentMnemonicPrompt,
  buildPremiumLockedPrompt,
  buildRevealedMnemonicUpsell,
  MNEMONIC_CATALOG_SIZE_LABEL,
} from "#mnemonic-gate-copy";
export {
  type MnemonicGateState,
  resolveMnemonicGateState,
  type ResolveMnemonicGateStateArgs,
  shouldShowRevealedMnemonicUpsell,
} from "#resolve-mnemonic-gate-state";
